require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-eisenstadt-und-umgebung-klingenbach.json") })
        }
      }, "path---betreuungseinrichtungen-eisenstadt-und-umgebung-klingenbach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-eisenstadt-und-umgebung-klingenbach!./.cache/json/betreuungseinrichtungen-eisenstadt-und-umgebung-klingenbach.json
// module id = 860
// module chunks = 231608221292675